<template>
  <div>
    <!-- 年度开工率 -->
    <Echart :options="options" id="bottomLeftChart" height="400px" width="100%"></Echart>
  </div>
</template>

<script>
import Echart from '@/common/echart'
export default {
  data() {
    return {
      options: {},
    };
  },
  components: {
    Echart,
  },
  props: {
    cdata: {
      type: Object,
      default: () => ({})
    },
  },
  watch: {
    cdata: {
      handler(newData) {
        this.options = {
          series: [
            // 1
            {
              type: 'gauge',
              startAngle: -90,
              endAngle: -450,
              radius: '40%',
              center: ['15%', '30%'],
              pointer: {
                show: false
              },
              progress: {
                show: true,
                overlap: false,
                roundCap: true,
                clip: false,
                itemStyle: {
                  borderWidth: 1,
                  borderColor: '#c46852'
                }
              },
              axisLine: {
                lineStyle: {
                  width: 10
                }
              },
              splitLine: {
                show: false,
                distance: 0,
                length: 10
              },
              axisTick: {
                show: false
              },
              axisLabel: {
                show: false,
                distance: 50
              },
              data: newData.gaugeData1,
              title: {
                fontSize: 18
              },
              detail: {
                width: 50,
                height: 14,
                fontSize: 20,
                color: 'auto',
                borderColor: 'auto',
                borderRadius: 20,
                borderWidth: 0,
                formatter: '{value}°C'
              }
            },
            // 2
            {
              type: 'gauge',
              startAngle: -90,
              endAngle: -450,
              radius: '40%',
              center: ['38%', '30%'],
              pointer: {
                show: false
              },
              progress: {
                show: true,
                overlap: false,
                roundCap: true,
                clip: false,
                itemStyle: {
                  borderWidth: 1,
                  borderColor: '#377888'
                }
              },
              axisLine: {
                lineStyle: {
                  width: 10
                }
              },
              splitLine: {
                show: false,
                distance: 0,
                length: 10
              },
              axisTick: {
                show: false
              },
              axisLabel: {
                show: false,
                distance: 50
              },
              data: newData.gaugeData2,
              title: {
                fontSize: 18
              },
              detail: {
                width: 50,
                height: 14,
                fontSize: 20,
                color: 'auto',
                borderColor: 'auto',
                borderRadius: 20,
                borderWidth: 0,
                formatter: '{value}%'
              }
            },
            // 3
            {
              type: 'gauge',
              startAngle: -90,
              endAngle: -450,
              radius: '40%',
              center: ['62%', '30%'],
              pointer: {
                show: false
              },
              progress: {
                show: true,
                overlap: false,
                roundCap: true,
                clip: false,
                itemStyle: {
                  borderWidth: 1,
                  borderColor: '#464646'
                }
              },
              axisLine: {
                lineStyle: {
                  width: 10
                }
              },
              splitLine: {
                show: false,
                distance: 0,
                length: 10
              },
              axisTick: {
                show: false
              },
              axisLabel: {
                show: false,
                distance: 50
              },
              data: newData.gaugeData3,
              title: {
                fontSize: 18
              },
              detail: {
                width: 50,
                height: 14,
                fontSize: 20,
                color: 'auto',
                borderColor: 'auto',
                borderRadius: 20,
                borderWidth: 0,
                formatter: '{value}°C'
              }
            },
            // 4
            {
              type: 'gauge',
              startAngle: -90,
              endAngle: -450,
              radius: '40%',
              center: ['85%', '30%'],
              pointer: {
                show: false
              },
              progress: {
                show: true,
                overlap: false,
                roundCap: true,
                clip: false,
                itemStyle: {
                  borderWidth: 1,
                  borderColor: '#464646'
                }
              },
              axisLine: {
                lineStyle: {
                  width: 10
                }
              },
              splitLine: {
                show: false,
                distance: 0,
                length: 10
              },
              axisTick: {
                show: false
              },
              axisLabel: {
                show: false,
                distance: 50
              },
              data: newData.gaugeData4,
              title: {
                fontSize: 18
              },
              detail: {
                width: 50,
                height: 14,
                fontSize: 20,
                color: 'auto',
                borderColor: 'auto',
                borderRadius: 20,
                borderWidth: 0,
                formatter: '{value}ppm'
              }
            },
            // 5
            {
              type: 'gauge',
              startAngle: -90,
              endAngle: -450,
              radius: '40%',
              center: ['15%', '77%'],
              pointer: {
                show: false
              },
              progress: {
                show: true,
                overlap: false,
                roundCap: true,
                clip: false,
                itemStyle: {
                  borderWidth: 1,
                  borderColor: '#c46852'
                }
              },
              axisLine: {
                lineStyle: {
                  width: 10
                }
              },
              splitLine: {
                show: false,
                distance: 0,
                length: 10
              },
              axisTick: {
                show: false
              },
              axisLabel: {
                show: false,
                distance: 50
              },
              data: newData.gaugeData5,
              title: {
                fontSize: 18
              },
              detail: {
                width: 50,
                height: 14,
                fontSize: 20,
                color: 'auto',
                borderColor: 'auto',
                borderRadius: 20,
                borderWidth: 0,
                formatter: '{value}°C'
              }
            },
            // 6
            {
              type: 'gauge',
              startAngle: -90,
              endAngle: -450,
              radius: '40%',
              center: ['38%', '77%'],
              pointer: {
                show: false
              },
              progress: {
                show: true,
                overlap: false,
                roundCap: true,
                clip: false,
                itemStyle: {
                  borderWidth: 1,
                  borderColor: '#377888'
                }
              },
              axisLine: {
                lineStyle: {
                  width: 10
                }
              },
              splitLine: {
                show: false,
                distance: 0,
                length: 10
              },
              axisTick: {
                show: false
              },
              axisLabel: {
                show: false,
                distance: 50
              },
              data: newData.gaugeData6,
              title: {
                fontSize: 18
              },
              detail: {
                width: 50,
                height: 14,
                fontSize: 20,
                color: 'auto',
                borderColor: 'auto',
                borderRadius: 20,
                borderWidth: 0,
                formatter: '{value}%'
              }
            },
            // 7
            {
              type: 'gauge',
              startAngle: -90,
              endAngle: -450,
              radius: '40%',
              center: ['62%', '77%'],
              pointer: {
                show: false
              },
              progress: {
                show: true,
                overlap: false,
                roundCap: true,
                clip: false,
                itemStyle: {
                  borderWidth: 1,
                  borderColor: '#464646'
                }
              },
              axisLine: {
                lineStyle: {
                  width: 10
                }
              },
              splitLine: {
                show: false,
                distance: 0,
                length: 10
              },
              axisTick: {
                show: false
              },
              axisLabel: {
                show: false,
                distance: 50
              },
              data: newData.gaugeData7,
              title: {
                fontSize: 18
              },
              detail: {
                width: 50,
                height: 14,
                fontSize: 20,
                color: 'auto',
                borderColor: 'auto',
                borderRadius: 20,
                borderWidth: 0,
                formatter: '{value}°C'
              }
            },
            // 8
            {
              type: 'gauge',
              startAngle: -90,
              endAngle: -450,
              radius: '40%',
              center: ['85%', '77%'],
              pointer: {
                show: false
              },
              progress: {
                show: true,
                overlap: false,
                roundCap: true,
                clip: false,
                itemStyle: {
                  borderWidth: 1,
                  borderColor: '#464646'
                }
              },
              axisLine: {
                lineStyle: {
                  width: 10
                }
              },
              splitLine: {
                show: false,
                distance: 0,
                length: 10
              },
              axisTick: {
                show: false
              },
              axisLabel: {
                show: false,
                distance: 50
              },
              data: newData.gaugeData8,
              title: {
                fontSize: 18
              },
              detail: {
                width: 50,
                height: 14,
                fontSize: 20,
                color: 'auto',
                borderColor: 'auto',
                borderRadius: 20,
                borderWidth: 0,
                formatter: '{value}ppm'
              }
            },
          ]
        }
      },
      immediate: true,
      deep: true
    },
  }
}
</script>